import React from "react"
import { useStateMachine } from "../../../context/stateMachine/StateMachineContext"
import { Steps } from "./step-library"
import { Container, FlexContainer, H2 } from "@carrotfertility/carotene"
import { Skip } from "../../../views/fle/Molecules"
import ButtonSelectGroup from "components/carrot-plans/shared/ButtonSelectGroup"
import useButtonMultiSelect from "components/carrot-plans/hooks/useButtonMultiSelect"
import { useRoutingInfo } from "components/carrot-plans/context/RoutingInfoContext"
import { HelperText } from "components/views/atoms/Atoms"
import ArrowSubmitButton from "components/carrot-plans/shared/ArrowSubmitButton"
import { useJourneyFlow } from "../../shared/JourneyFlowContainer"

const ViewName = Steps.DO_ANY_APPLY

function determineNextStep(selectedValues): "SELECTED" | "NONE_SELECTED" {
  return selectedValues.length ? "SELECTED" : "NONE_SELECTED"
}

export default function DoAnyOfTheFollowingApplyStep(): JSX.Element {
  const { updateRoutingInfo, routingData, hasQuestionBeenSkipped } = useRoutingInfo()
  const defaultValues = routingData?.doAnyApply || []
  const { handleContinueLoading, continueLoading } = useJourneyFlow()

  const { setNextStep } = useStateMachine(
    ViewName,
    (() => {
      if (routingData?.doAnyApply) {
        return determineNextStep(routingData?.doAnyApply)
      }
      if (hasQuestionBeenSkipped("doAnyApply")) {
        return "NONE_SELECTED"
      }
      return null
    })()
  )
  const buttonControls = useButtonMultiSelect({
    options: [
      {
        title: "Over the age of 40",
        id: "OVER_40"
      },
      {
        title: "Two or more unintended pregnancy losses",
        id: "TWO_LOSSES"
      },
      {
        title: "Urgent medical need for fertility preservation",
        id: "URGENT_MEDICAL_NEED"
      },
      {
        title: "Never menstruated",
        id: "NEVER_MENSTRUATED"
      },
      {
        title: "Immediate family member with history of blood clotting disorders",
        id: "FAMILY_BLOOD_CLOTTING"
      }
    ],
    defaultValues
  })

  async function onClickContinue(): Promise<void> {
    await handleContinueLoading(() => updateRoutingInfo({ doAnyApply: buttonControls.multiSelected }))
    setNextStep(ViewName, determineNextStep(buttonControls.multiSelected))
  }

  async function onSkip(): Promise<void> {
    await handleContinueLoading(() => updateRoutingInfo({ skipFields: ["doAnyApply"] }))
    setNextStep(ViewName, "SKIP")
  }

  return (
    <form
      onSubmit={(event) => {
        event.preventDefault()
        onClickContinue()
      }}
    >
      <Container stack="large">
        <H2 stack="tiny">Do any of the following apply?</H2>
        <HelperText>Select as many as apply.</HelperText>
      </Container>
      <Container>
        <ButtonSelectGroup loading={continueLoading} {...buttonControls} />
      </Container>
      <FlexContainer paddingTopBottom="huge" justifyContent="space-between">
        <Skip onClick={onSkip} onClickOnly enabled={!continueLoading} />
        <ArrowSubmitButton enabled={!continueLoading}>Continue</ArrowSubmitButton>
      </FlexContainer>
    </form>
  )
}
